module.exports = __webpack_public_path__ + "static/paths_refresher_home-ef4316937bac59ab62c332dae0a822c7.svg";